import React from 'react';

import { createComponent, Layout, Header, Button, Label, enums } from 'console-kit';
import authStatics from '../../../common/static';
import { connect } from 'react-redux';

import DeniedPanelActions from '../redux/actions';
import AuthImageLogo from '../../../components/AuthImageLogo';

const DeniedPanel = createComponent({
  displayName: 'DeniedPanel',
  handlers:    {
    handleClick: p => (e, { value }) => {
      p.onRedirect();
      window.location.href = value;
    },
  },
  render(props) {
    return (
      <div className={authStatics.SCREEN_CLASSES}>
        <Layout isFluidHeight>
          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.CENTER}>
              <AuthImageLogo />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.LEFT}>
              <Header
                text="Sorry!"
                isDividing={false}
                font={{
                  emphasis: enums.font.emphasis.NORMAL,
                }}
                size={enums.sizes.X6}
              />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.LEFT}>
              <Label
                text="You are not authorised to view this page."
                hasPadding={false}
                display={enums.display.PLAIN}
                size={enums.sizes.X4}
                isFluid
              />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Button.WithAnimation
              actions={{
                start:   DeniedPanelActions.redirectRequest,
                success: DeniedPanelActions.redirectRequestSuccess, //no action
                failure: DeniedPanelActions.redirectRequestFailure, //no action
              }}
            >
              <Button.Primary
                text="Login"
                value={authStatics.DENIEDACCESS_REDIRECT_URL}
                float={enums.positions.RIGHT}
                size={enums.sizes.X4}
                onClick={props.handleClick}
                textAlign={enums.textAlignments.CENTER}
                color={enums.colors.ACCENT}
                isSolid
                isFluid
                isDisabled={false}
              />
            </Button.WithAnimation>
          </Layout.Row>
        </Layout>
      </div>
    );
  },
});

export default connect(null, dispatch => ({
  onRedirect() {
    dispatch(DeniedPanelActions.redirectRequest());
  },
}))(DeniedPanel);
